import { createFileRoute } from "@tanstack/react-router";

import CompetitionRoutes from "@/components/CompetitionRoutes/CompetitionRoutes";

export const Route = createFileRoute("/gym/$venueUuid/events/$competitionUuid/routes")({
  component: CompetitionRoutes,
  beforeLoad: () => {
    return {
      switchVenueLinkOpts: {
        path: "/gym/$venueUuid/events",
        search: { tab: "routes" },
      },
    };
  },
});
